import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: `
    <div
      style="width: 100%; max-width: 250px;margin-left: auto;margin-right: auto;"
    >
      <risk-heat-bar [version]="'v2'" [risk]="rating"></risk-heat-bar>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingBarV2Component
  extends DataWidgetComponent
  implements OnInit
{
  @Input()
  data: MobileAppPtiRanking;

  rating: string;

  ngOnInit(): void {
    super.ngOnInit();

    this.rating = this.data[this.key];
  }
}
